<template>
  <div>
    <div
      class="content"
      style="margin-bottom: 10px"
    >
      <div
        class="header pure-g"
        style="padding-left: 10%"
      >
        <div
          class="pure-u-8-24 logo-header-container"
        >
          <router-link to="/">
            <img
              src="../assets/logo-header.png"
              class="logo-header"
              alt="APKollens logga, en tecknad orange apa som dricker öl"
            >
          </router-link>
        </div>
        <div
          class="pure-u-16-24"
          style="text-align: left; margin-top: auto; margin-left: auto;"
        >
          <h1 class="page-header">
            Nyheter
          </h1>
          <h2 class="page-subheader">
            <i>Som Aftonbladet, men med mer integritet</i>
          </h2>
        </div>        
      </div>
    </div>
    <div
      class="content"
      style="text-align: left;"
    >
      <h2 class="content-subhead">
        Här var det tomt...
      </h2>
    </div>
  </div>
</template>

<script>
export default {
    name: 'News',
    metaInfo: {
      title: "Nyheter | APKollen.se",
      meta: [
        { description: "Nyheter och annat kul från oss" },
      ]
    },
}
</script>
